// eslint-disable-next-line import/no-extraneous-dependencies
import type { Promotion } from '@packages/modules/src/PromotionBanner/types';
import { atom } from 'jotai';

export const remotePromotion = atom<Promotion | null>(null);
